// Common Constants

import { Feature } from '../models';

export const SIDEBAR_WIDTH = 264;
export const SIDEBAR_COLLAPSED_WIDTH = 74;
export const MAX_ACCOUNT_NAME_LENGTH = 30;
export const USD_CURRENCY = 'USD';

// Katalon Studio download link

// term and policy links
export const CUSTOMER_TERM_OF_USED = 'https://katalon.com/terms#customer-terms-of-use';
export const CUSTOMER_PRIVACY_POLICY = 'https://katalon.com/terms#privacy-policy';

export const PARTNER_ID_COOKIE_NAME = 'katalon_partner_id';

export const TRACKING_QUERY_PARAMS = [
  'gaClientId',
  'gaSessionId',
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_term',
  'utm_content',
];
export const TRACKING_COOKIES = [
  '_fbp',
  '_fbc',
  ...TRACKING_QUERY_PARAMS,
];
export const PRODUCT_QUERY_PARAMS = [
  'kse_per-user_monthly',
  'kse_per-user_annual',
  'kre_floating_monthly',
  'kre_floating_annual',
  'testcloud_session_webdesktop_monthly',
  'testcloud_session_webdesktop_annual',
  'testcloud_session_mobileapp_monthly',
  'testcloud_session_mobileapp_annual',
  'testcloud_session_crossbrowser_monthly',
  'testcloud_session_crossbrowser_annual',
  'true_platform_monthly',
  'true_platform_annual',
  'true_platform_ecom_annual',
  'true_automation_monthly',
  'true_automation_annual',
  'true_automation_ecom_annual',
  'true_bundle_manual_ecom_annual',
  'true_bundle_automation_ecom_annual',
];

export const PLAN_FEATURE_QUERY_PARAM = 'feature';
export const PLAN_QUANTITY_QUERY_PARAM = 'quantity';
export const PLAN_BILLING_QUERY_PARAM = 'billing';
export const PLAN_SUBSCRIPTION_ID_QUERY_PARAM = 'subscriptionId';
export const ACCOUNT_SELECTION_ROUTE_QUERY_PARAM = 'route';

export const BOOLEAN_QUERY_PARAMS = [
  'ftic',
];

/**
 * Features the plan page can still pre-select from quota/cycle query params — i.e. the ones that
 * are still on sale self-serve. R6 (Decision 16) dropped True Automation and True Platform: a
 * "Repurchase these items" band must not push a retired SKU back into the cart, because the BE now
 * answers `legacy.true.sku.retired` on every self-serve route.
 */
export const SUPPORTED_FEATURES = [
  Feature.TRUE_TEAM,
  // True Bundle Starters: the plan page pre-selects them from their quota param as the whole
  // package (quantity 1) - "Repurchase these items" and the order-confirmation rebuild both
  // travel through these params.
  Feature.TRUE_BUNDLE_MANUAL,
  Feature.TRUE_BUNDLE_AUTOMATION,
  Feature.PER_USER_KSE,
  Feature.UNLIMITED_ENGINE,
  Feature.TESTCLOUD_SESSION_CROSS_BROWSER,
  Feature.TESTCLOUD_SESSION_MOBILE_APP,
  Feature.TESTCLOUD_SESSION_PRIVATE_DEVICE,
  Feature.TESTCLOUD_SESSION_LIVE_TESTING,
  Feature.TESTOPS_G3,
];

/**
 * Retired self-serve SKUs (R6 / Decision 16). They are no longer buyable, but their quota/cycle
 * query params must still be SWEPT out of the URL when leaving the plan page — an old pricing-page
 * link would otherwise leave `?trueAutomationQuota=1` stuck on every later route.
 */
export const RETIRED_SELF_SERVE_FEATURES = [
  Feature.TRUE_AUTOMATION,
  Feature.TRUE_PLATFORM_ONLY,
];

export const TRUE_TESTCLOUD_ADDON_FEATURES = [
  Feature.TESTCLOUD_SESSION_CROSS_BROWSER,
  Feature.TESTCLOUD_SESSION_MOBILE_APP,
  Feature.TESTCLOUD_SESSION_PRIVATE_DEVICE,
];

export const DEFAULT_CURRENCY_FORMAT_OPTIONS = {
  currency: USD_CURRENCY,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};
